import axiosApi from "../axiosInstance";
import { getReduxCompany } from "../../helper/sessionHelper";

const getPaymentRequestList = async (body) => {
    try {
        body = body || {};
        body.companyId = getReduxCompany()?.companyId || 0;

        const response = await axiosApi.post(`/PaymenttRequest/GetPaymentRequestList`, body);
        return response?.data;
    } catch (error) {
        console.log("Error getPaymentRequestList===>:", error);
    }
};

const getPaymentRequestDetailsByPRId = async (body) => {
    try {
        body = body || {};
        body.companyId = getReduxCompany()?.companyId || 0;
        
        const response = await axiosApi.post(`/PaymenttRequest/GetPaymentRequestDetailsByPrId`, body);
        return response?.data;
    } catch (error) {
        console.log("Error getPaymentRequestDetailsByPRId===>:", error);
    }
};

const approvePaymentRequest = async (body) => {
    try {
        const response = await axiosApi.post(`PaymenttRequest/ApprovePaymentRequest`, body);
        return response?.data;
    } catch (error) {
        console.log("Error ApprovePaymentRequest ===>", error);
        return error?.response?.data;
    }
};
const rejectPaymentRequest = async (body) => {
    try {
        const response = await axiosApi.post(`PaymenttRequest/RejectPaymentRequest`, body);
        return response?.data;
    } catch (error) {
        console.log("Error RejectPaymentRequest ===>", error);
        return error?.response?.data;
    }
};
const Payment = async (body) => {
    try {
        const response = await axiosApi.post(`PaymentRequestItem/UpdatePaymentOfPrItem`, body);
        return response?.data;
    } catch (error) {
        console.log("Error Payment ===>", error);
        return error?.response?.data;
    }
};



async function getitemPaymentDetailsById(itemId) {
    try {
        const response = await axiosApi.post(`/PaymentRequestItem/GetPaymentItemDetailsByPRItemId/` + itemId);
        return response?.data;
    } catch (error) {
        console.log("Error getUserDropdown===>:", error);
        return null;
    }
};

const deletePR = async (body) => {
    try {
        const response = await axiosApi.post(`PaymenttRequest/DeletePaymentRequest`, body);
        return response?.data;
    } catch (error) {
        console.log("Error deletePR ===>", error);
        return error?.response?.data;
    }
};




const getPaymentModeList = async () => {
    try {
        const response = await axiosApi.get(`/PaymentModeDetails/PaymentModeDetails`);
        return response?.data;
    } catch (error) {
        console.log("Error getMsmeList===>:", error);
    }
};


const getPaymentRequestItemsByRequestId = async (requestId, userId) => {
    try {
        const response = await axiosApi.post(`PaymentRequestItem/GetPaymentRequestItemsByRequestId/${requestId}/${userId}`);
        return response?.data;
    } catch (error) {
        console.log("Error getPaymentRequestItemsByRequestId ===>", error);
        return error?.response?.data;
    }
};

const updatePaymentRequest = async (body) => {
    debugger
    try {
        const response = await axiosApi.post(`PaymenttRequest/UpdatePaymentRequest`, body, { headers: { "Content-Type": "multipart/form-data" } });
        return response?.data;
    } catch (error) {
        console.log("Error updatePaymentRequest ===>", error);
    }
};

export const PaymentRequestService = {
    getPaymentRequestList,
    //addPaymentRequest,
    updatePaymentRequest,
    getPaymentRequestDetailsByPRId,
    Payment,
    deletePR,
    // approveRejectPaymentRequest,
    // deletePaymentRequestItemByItemId,
    approvePaymentRequest,
    rejectPaymentRequest,
    getitemPaymentDetailsById,
    getPaymentRequestItemsByRequestId,
    getPaymentModeList
}